const type = 'RESET_DISPUTE';

const resetDispute = () => ({
  type,
});

export { type };
export default resetDispute;
